import {NgModule} from "@angular/core";
import {LoginComponent} from "./shared/auth/login/login.component";
import {RouterModule, Routes} from "@angular/router";
import {PasswordResetLinkComponent} from "./core/visbos-core/components/password-change/password-reset-link/password-reset-link.component";
import {PasswordResetFormComponent} from "./core/visbos-core/components/password-change/password-reset-form/password-reset-form.component";
import {LogOutComponent} from "./core/visbos-core/components/log-out/log-out.component";
import {MaintenanceViewComponent} from "./core/visbos-core/views/maintenance-view/maintenance-view.component";

const visbosRoutes: Routes = [
  {
    path: '',
    redirectTo: 'client',
    pathMatch: 'full'
  },
  {
    path: 'login',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'passwort/link',
        component: PasswordResetLinkComponent
      },
      {
        path: 'passwort/reset/:token',
        component: PasswordResetFormComponent
      }
    ]
  },
  {
    path: 'logout',
    children: [
      {
        path: '',
        component: LogOutComponent,
      }
    ]
  },
  {
    path: 'maintenance',
    children: [
      {
        path: '',
        component: MaintenanceViewComponent,
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(visbosRoutes, {useHash: true})
  ],
  exports: [
    RouterModule
  ]
})
export class VisBosRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/visbos-routing.module.ts